import React, { useState, useEffect } from "react";
import { IoMdBusiness } from "react-icons/io";
import { FaUsers } from "react-icons/fa6";
import { PiTreeStructureFill } from "react-icons/pi";
import { CgEditHighlight } from "react-icons/cg";
import { BsFillClipboard2DataFill, BsRobot } from "react-icons/bs";
import CompanyChatbot from "./Chatbot/CompanyChatbot";
import chatbotStyles from "./Chatbot/CompanyChatbot.module.css";
import { IoGitCompareOutline } from "react-icons/io5";
import { AiFillFund } from "react-icons/ai";
import { RiFileSearchFill, RiFundsLine } from "react-icons/ri";
import { CiShare2 } from "react-icons/ci";
import DownloadModal from "./DownloadModal";
import {
    creditPricing,
    createRazorpayOrder,
    handlePaymentSuccess,
    getStates,
    getUserInvoiceForm,
} from "../../Services/APIrequests";

import {
    FaWhatsapp,
    FaLock,
    FaGoogle,
    FaLinkedin,
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaLink,
    FaShieldAlt,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { companyMaster } from "../../Services/APIrequests";
import { useSearchParams } from "react-router-dom";
import {
    searchCompaniesById,
    buyCompanyData,
    history,
    getCompanynotoken,
    getExpiredPurchasedCompaniesByUser,
    constRefresh,
    getcompanyReport,
    getMykohere,
    getCompanyPurchase,
} from "../../Services/APIrequests";
import Swal from "sweetalert2";
import { MdFileDownload, MdSwitchAccessShortcutAdd } from "react-icons/md";
import { TbRefresh } from "react-icons/tb";
import { IoMdLock } from "react-icons/io";
import styles from "./commanstyles.module.css";
import billingStyles from "./proPlanTab.module.css";
import Layout from "../../Components/Layout";
import Aboutcompany from "./aboutthecompany/Aboutcompany";
import Directorslist from "./Directors/Directorslist";
import IndexCharges from "./IndexofCharges/IndexCharges";
import FinacialData from "./Financialdata/Financialdata";
import Companystructure from "./Company Structure/Companystructure";
import SourceDocuments from "./SourceDocuments/SourceDocuments";
import CompanyHighlights from "./CompanyHighlights/CompanyHighlights";
import ComplianceCheck from "./ComplianceCheck/ComplianceCheck";
import Chargedetails from "./Chargedetails/Chargedetails";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useStore from "../../Store";
import { setAuthToken } from "../../Services/config";
import { SuccessSwal, warningSwal } from "../../Util/Toast";

const CompanyDetails = (url) => {
    const location = useLocation();
    const { CIN, setCIN } = useStore();
    const { cin } = useParams();
    const pathname = location.pathname;
    const [searchparams, setSearchParams] = useSearchParams();
    const [status, setStatus] = useState(
        searchparams.get("status") ? Number(searchparams.get("status")) : 1
    );
    const [loading, setLoading] = useState(true);
    const [lockload, setLockload] = useState(false);
    const [error, setError] = useState(null);
    const [isMarked, setisMarked] = useState(true);
    const [companyInfo, setCompanyInfo] = useState({});
    const { isSubScribe, setIssubscribe } = useStore((item) => item);
    const [purchasedCompanies, setPurchasedCompanies] = useState([]);
    const [expiredCompanies, setExpiredCompanies] = useState([]);
    // const DateOfPurchase = purchasedCompanies.length > 0 ? purchasedCompanies[0].DateOfPurchase : null;
    const [isLocked, setIsLocked] = useState(true);
    const [companyName, setCompanyName] = useState();
    const [dateOfPurchase, setDateOfPurchase] = useState(null);
    // const [isSubscribe, setIsSubscribe] = useState(false);
    const navigate = useNavigate();
    const { token } = useStore();
    const [refreshLoading, setRefreshLoading] = useState(false);
    const [showShareOptions, setShowShareOptions] = useState(false);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [updatedRefreshTime, setUpdatedRefreshTime] = useState(null);
    const { idType } = location.state || {};
    const [pricingData, setPricingData] = useState({});
    const [purchaseData, setPurchaseData] = useState(null);
    const [showFloatingChat, setShowFloatingChat] = useState(false);

    // Billing modal (one-time payment unlock)
    const [showBillingModal, setShowBillingModal] = useState(false);
    const [statesList, setStatesList] = useState([]);
    const [fetchingBilling, setFetchingBilling] = useState(false);
    const [pendingUnlockCIN, setPendingUnlockCIN] = useState(null);
    const [billingDetails, setBillingDetails] = useState({
        fullName: "",
        email: "",
        mobileNumber: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        pincode: "",
        GSTIN: "",
        invoiceType: "B2C",
    });

    useEffect(() => {
        const fetchStates = async () => {
            try {
                const response = await getStates();
                setStatesList(response.data.states || []);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        fetchStates();
    }, []);

    const handleBillingInputChange = (e) => {
        const { name, value } = e.target;
        setBillingDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const getTimeAgo = (timestamp) => {
        const now = new Date();
        const updated = new Date(timestamp);
        const diff = Math.floor((now - updated) / 1000);

        if (diff < 60) return "Refreshed just now";
        if (diff < 3600) return `Refreshed ${Math.floor(diff / 60)} min ago`;
        if (diff < 86400)
            return `Refreshed ${Math.floor(diff / 3600)} hour${Math.floor(diff / 3600) > 1 ? "s" : ""
                } ago`;
        if (diff < 604800)
            return `Refreshed ${Math.floor(diff / 86400)} day${Math.floor(diff / 86400) > 1 ? "s" : ""
                } ago`;

        return `Refreshed on ${updated.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        })}`;
    };

    const handleShareClick = (e) => {
        e.stopPropagation();
        setShowShareOptions(!showShareOptions);
    };

    const handleDownload = async (format) => {
        try {
            let updatedFormat = null
            if (format == 'excel') {
                updatedFormat = 'xlsx'
            }
            else {
                updatedFormat = format
            }
            const response = await getcompanyReport(cin, updatedFormat);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${companyName}.${updatedFormat}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setShowDownloadModal(false);
        } catch (error) {
            console.error("Error downloading report:", error);
            alert("Failed to download the report. Please try again.");
        }
    };

    useEffect(() => {
        setStatus(
            searchparams.get("status") ? Number(searchparams.get("status")) : 1
        );
    }, [searchparams.get("status")]);

    useEffect(() => {
        const fetchExpiredCompanies = async () => {
            try {
                const response = await getExpiredPurchasedCompaniesByUser(
                    token
                );
                const expiredCompanies = response.data.expiredCompanies || [];
                expiredCompanies.forEach((company) => {
                    const validUpto = new Date(company.ValidUpto);
                    const today = new Date();
                    if (validUpto < today) {
                        setIsLocked(true);
                    }
                });

                setExpiredCompanies(expiredCompanies);
            } catch (error) {
                console.error(
                    "Error fetching expired purchased companies:",
                    error
                );
            } finally {
                setLoading(false);
            }
        };

        fetchExpiredCompanies();
    }, [navigate]);

    useEffect(() => {
        const fetchCreditPricing = async () => {
            try {
                const response = await creditPricing();
                // setPricingData();
                if (response.data?.length > 0) {
                    let pricingData = response.data?.filter(
                        (item) => item.minCredits == 1
                    );
                    if (pricingData.length > 0) {
                        setPricingData(pricingData[0]);
                    }
                }
                console.log("fetching credit pricing:", response.data);
            } catch (error) {
                console.error("Error fetching credit pricing:", error);
            }
        };
        fetchCreditPricing();
    }, []);

    const fetchCompanyData = async (cin, token) => {
        setLoading(true);
        try {
            let response;
            if (token) {
                response = await searchCompaniesById(cin, token);
            } else {
                response = await getCompanynotoken(cin);
            }

            const companies = response?.data?.purchasedCompanies || [];

            // ✅ Save companyName for reuse
            if (response?.data?.companyWithTopData) {
                // setisMarked(response.data.companyWithTopData.isMarked == 1);
                const companyName =
                    response.data.companyWithTopData.CompanyName;
                setCompanyName(companyName);
                sessionStorage.setItem("companyName", companyName);
            }

            setPurchasedCompanies(companies);

            if (companies.length === 0) {
                // 🔒 only lock if it was never unlocked
                if (isLocked) {
                    setIssubscribe(false);
                    setIsLocked(true);
                    setDateOfPurchase(null);
                }
            } else {
                const company = companies.find(
                    (item) => item.CompanyID === cin
                );
                if (company) {
                    const validUpto = new Date(company.ValidUpto);
                    const today = new Date();

                    if (validUpto > today) {
                        setIssubscribe(true);
                        setIsLocked(false); // ✅ keep it unlocked after refresh
                        fetchPurchaseStatus(cin);
                    }

                    setDateOfPurchase(company.DateOfPurchase);
                } else {
                    if (isLocked) {
                        setIsLocked(true);
                        setIssubscribe(false);
                        setDateOfPurchase(null);
                    }
                }
            }

            // ✅ Restore refresh time if available
            const storedRefreshTime = localStorage.getItem(
                `refreshTime-${cin}`
            );
            let refreshDate = response?.data?.companyWithTopData?.refreshProteanApi || null
            if (refreshDate) {
                setUpdatedRefreshTime(refreshDate);
            }
        } catch (err) {
            console.error("Error fetching company data:", err);
            setError("Failed to fetch company data");
        } finally {
            setLoading(false);
        }
    };

    const fetchPurchaseStatus = async (cin) => {
        try {
            const response = await getCompanyPurchase(cin);
            if (response.data && response.data.purchased) {
                setPurchaseData(response.data.purchased);
            }
        } catch (error) {
            console.error("Error fetching purchase status:", error);
        }
    };

    // ✅ Refresh button handler
    const handleRefresh = async () => {
        try {
            setRefreshLoading(true);
            const body = { cin, caseId: "123456" };
            const response = await companyMaster(body);

            if (response?.data) {
                const now = new Date().toISOString();
                setUpdatedRefreshTime(now);
                localStorage.setItem(`refreshTime-${cin}`, now);

                // 🔄 just refetch without reload
                await fetchCompanyData(cin, token);
            }
        } catch (err) {
            console.error("CompanyMaster refresh failed", err);
            if (err.response?.status === 401) {
                sessionStorage.removeItem("token");
                navigate("/login", { state: { from: location.pathname } });
            }
        } finally {
            setRefreshLoading(false);
        }
    };

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        setAuthToken(token);

        if (cin) {
            setIsLocked(true);
            setTimeout(() => {
                fetchCompanyData(cin, token);
            }, 10);
        }
    }, [cin, token]);

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const body = { companyName, CIN };
                const response = await history(body);
            } catch (err) {
                console.error("Error fetching history data:", err);
            }
        };

        if (companyName) {
            fetchHistory();
        }
    }, [companyName]);

    let subscribeUrl = `/kohere/Companydetails/${cin}/subscribe`;

    useEffect(() => {
        if (subscribeUrl === pathname) {
            setIssubscribe(true);
        }
        setCIN(cin);
        // const activeTab = sessionStorage.getItem("activeTab");
        // const ParseActiveTab = JSON.parse(activeTab);
        // setStatus(parseInt(ParseActiveTab) || 1);
        // setStatus(1);
    }, [pathname, subscribeUrl]);

    const handleUnlock = async (CIN) => {
        setLockload(true);
        const token = sessionStorage.getItem("token");
        if (!token) {
            navigate("/login", { state: { from: location.pathname } });
            setLockload(false);
            return;
        }
        try {
            const requestBody = {
                companyId: CIN,
            };
            const response = await buyCompanyData(token, requestBody);
            if (response.status === 200) {
                setIssubscribe(true);
                setIsLocked(false);
                setDateOfPurchase(new Date().toISOString());
                fetchPurchaseStatus(CIN);
                alert("Data unlocked successfully and credits reduced!");
            } else {
                setError("Failed to unlock data.");
            }
        } catch (error) {
            setError(
                error.message || "An error occurred while unlocking data."
            );
            warningSwal(error.response.data.message, "warning");
        } finally {
            setLockload(false);
        }
    };
    const handleStatusButtonClick = (status) => {
        let token = sessionStorage.getItem("token");
        if (status === 1 || status === 2 || status === 3 || status === 10) {
            setStatus(status);
            setSearchParams({ status: status });
            // sessionStorage.setItem("activeTab", status);
        } else if (token) {
            setStatus(status);
            setSearchParams({ status: status });
            // sessionStorage.setItem("activeTab", status);
        } else {
            navigate("/login", { state: { from: location.pathname } });
        }
    };

    const isActiveButton = (buttonStatus) => {
        return status === buttonStatus ? styles.active : "";
    };

    const billingSubtotal = Number(pricingData?.pricePerCredit) || 0;
    const billingGstPercentage = 18;
    const billingGst = billingSubtotal * (billingGstPercentage / 100);
    const billingTotal = billingSubtotal + billingGst;

    const handleSubscribe = async (
        razorpay_order_Id,
        razorpay_payment_id,
        credits,
        CIN,
        billingData = {}
    ) => {
        try {
            const data2 = {
                razorpay_order_id: razorpay_order_Id,
                razorpay_payment_id: razorpay_payment_id,
                credits: credits,
                type: "purchase",
                cin: CIN,
                ...billingData,
            };

            const paymentCartDetailsApi1 = await handlePaymentSuccess(data2);

            if (paymentCartDetailsApi1.status === 200) {
                handleUnlock(CIN);
            } else {
                alert(
                    paymentCartDetailsApi1.message ||
                    "Something went wrong while processing the subscription."
                );
            }
        } catch (error) {
            console.error("Error in handleSubscribe:", error);
            alert("An unexpected error occurred. Please try again.");
        }
    };

    const handleFinalPayment = async () => {
        if (
            !billingDetails.fullName ||
            !billingDetails.email ||
            !billingDetails.mobileNumber ||
            !billingDetails.address1 ||
            !billingDetails.city ||
            !billingDetails.state ||
            !billingDetails.pincode
        ) {
            alert("Please fill in all required fields.");
            return;
        }

        try {
            const subtotal = billingSubtotal;
            const gstPercentage = 18;
            const gstAmount = subtotal * (gstPercentage / 100);
            const totalAmount = subtotal + gstAmount;
            const roundedAmount = parseFloat(totalAmount.toFixed(2));

            const paymentCartDetailsApi = await createRazorpayOrder({
                amount: roundedAmount,
                type: "purchase",
            });

            if (paymentCartDetailsApi.status === 201) {
                const billingData = {
                    ...billingDetails,
                    invoiceType: "purchase",
                    credit: 1,
                    creditAmount: pricingData?.pricePerCredit,
                    subtotal: subtotal,
                    totalamount: roundedAmount,
                    gstPercentage: gstPercentage,
                    gstAmount: gstAmount,
                };

                const options = {
                    key: process.env.REACT_APP_RAZORPAYKEY_TEST,
                    amount: roundedAmount * 100,
                    currency: "INR",
                    name: "Kohere",
                    description: "Order Payments",
                    order_id: paymentCartDetailsApi.data.data.razorpay_orderId,
                    handler: function (response) {
                        if (response.razorpay_payment_id !== null) {
                            handleSubscribe(
                                paymentCartDetailsApi.data.data.razorpay_orderId,
                                response.razorpay_payment_id,
                                1,
                                pendingUnlockCIN,
                                billingData
                            );
                        } else {
                            alert("Something went wrong, please try again.");
                        }
                    },
                    prefill: {
                        name: billingDetails.fullName,
                        email: billingDetails.email,
                        contact: billingDetails.mobileNumber,
                    },
                    theme: {
                        color: "#1F66FF",
                    },
                };
                const rzp1 = new window.Razorpay(options);
                rzp1.open();
                setShowBillingModal(false);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while processing the payment.");
        }
    };

    const handlePayment = async (roundedAmount, CIN) => {
        try {
            const paymentCartDetailsApi = await createRazorpayOrder({
                amount: roundedAmount,
            });
            if (paymentCartDetailsApi.status === 201) {
                const options = {
                    // key: "rzp_test_8fofedsVTbn7Vv", /*dev*/
                    key: process.env.REACT_APP_RAZORPAYKEY_TEST /*prod*/,
                    amount: roundedAmount * 100,
                    currency: "INR",
                    name: "Kohere",
                    description: "Order Payments",
                    order_id: paymentCartDetailsApi.data.razorpay_orderId,
                    handler: function (response) {
                        if (response.razorpay_payment_id !== null) {
                            handleSubscribe(
                                paymentCartDetailsApi.data.data
                                    .razorpay_orderId,
                                response.razorpay_payment_id,
                                1,
                                CIN
                            );
                        } else {
                            alert("Something went wrong, please try again.");
                        }
                    },
                    prefill: {
                        name: "kohere",
                        email: "kohere@gmail.com",
                        // contact: 9010234589,
                    },
                    notes: {
                        address: "",
                    },
                    theme: {
                        color: "#FDFBB9",
                    },
                };
                const rzp1 = new window.Razorpay(options);
                rzp1.open();
            }
            // Return the order response so callers can await completion of createRazorpayOrder
            return paymentCartDetailsApi;
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while processing the payment.");
            throw error;
        }
    };
    const unlockCompany = async (CIN) => {
        const companyTitle = companyName ? companyName : "this company";
        const token = sessionStorage.getItem("token");
        if (!token) {
            navigate("/login", { state: { from: location.pathname } });
            return;
        }

        let contactCredits = 0;
        try {
            const resp = await getMykohere(token);
            contactCredits = resp?.data?.user?.credits || 0;
        } catch (err) {
            console.error("Failed to fetch user credits", err);
        }

        const creditDisabled = contactCredits <= 0 ? "disabled" : "";
        const noCreditsNote =
            contactCredits <= 0 ? "(No Credits Available)" : "";

        Swal.fire({
            title: `Unlock ${companyTitle}`,
            html: `
                                <div style="font-family:inherit; text-align:left;">
                                    <div style="margin-bottom:10px; font-weight:600; color:#333;">Select Payment Method</div>

                                    <div style="display:flex; gap:12px; margin-bottom:14px;">
                                        <label class="swal-unlock-label" data-value="pay" style="flex:1; border-radius:10px; padding:14px; display:flex; align-items:center; gap:12px; cursor:pointer; background:#fff; position:relative;">
                                            <input id="swal-unlock-pay" type="radio" name="unlockOption" value="pay" style="display:none;" />
                                            <div class="swal-unlock-check" style="width:36px;height:36px;border-radius:50%;background:var(--PrimaryColor);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:18px;">✓</div>
                                            <div>
                                                <div style="font-size:16px;color:var(--PrimaryColor);font-weight:600;">Pay ₹${pricingData?.pricePerCredit
                }</div>
                                                <div style="font-size:12px;color:var(--PrimaryColor);">One-time payment</div>
                                            </div>
                                        </label>

                                        <label class="swal-unlock-label" data-value="credit" style="flex:1; border:2px dashed #dcdcdc; border-radius:10px; padding:14px; display:flex; align-items:center; gap:12px; cursor:pointer; background:#fafafa; position:relative;">
                                            <div class="swal-unlock-check" style="width:36px;height:36px;border-radius:50%;background:var(--PrimaryColor);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:18px;">✓</div>
                                            <input id="swal-unlock-credit" type="radio" name="unlockOption" value="credit" ${creditDisabled} style="display:none;" />
                                          
                                            <div>
                                                <div style="font-size:16px;color:#444;font-weight:600;">Pay using Credit</div>
                                                <div style="font-size:12px;color:${contactCredits <= 0
                    ? "#d9534f"
                    : "#999"
                };">${contactCredits <= 0 ? "No Credits Available" : "Use 1 credit"
                }</div>
                                            </div>
                                        </label>
                                    </div>

                                    <div style="margin:14px 0;">
                                        <button id="swal-buy-credits" style="background:var(--PrimaryColor);color:#fff;padding:12px 18px;border-radius:8px;border:none;box-shadow:0 6px 18px rgba(0,0,0,0.08);cursor:pointer;width:100%;">Unlock Attractive Prices & Single Click Purchasing Credits!</button>
                                    </div>

                                    <div style="margin-top:12px; font-size:13px; color:#333; text-align:left;">
                                        <strong>Additional Information</strong>
                                        <ul style="margin:8px 0 0 18px; color:#444;">
                                            <li>View corporate profile for you view the year from a year from rom unlock date.</li>
                                            <li>Prices shown exclusive of GST.</li>
                                        </ul>
                                    </div>
                                </div>
                        `,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: "Proceed to Checkout",
            cancelButtonText: "Cancel",
            showLoaderOnConfirm: true,
            didOpen: () => {
                const buyBtn = document.getElementById("swal-buy-credits");
                if (buyBtn) {
                    buyBtn.addEventListener("click", () => {
                        // navigate to buy credits page
                        navigate("/kohere/mycredits", {
                            state: {
                                from: `/kohere/Companydetails/${cin}`,
                                active: "BuyCredits",
                            },
                        });
                        Swal.close();
                    });
                }

                // Wire up selectable labels so only one is highlighted at a time
                const labels = document.querySelectorAll(".swal-unlock-label");

                function updateSelection(value) {
                    labels.forEach((lbl) => {
                        const input = lbl.querySelector(
                            'input[name="unlockOption"]'
                        );
                        const check = lbl.querySelector(".swal-unlock-check");
                        if (!input) return;
                        if (lbl.dataset.value === value) {
                            input.checked = true;
                            lbl.style.boxShadow = "0 4px 14px rgba(0,0,0,0.08)";
                            lbl.style.border = "2px solid var(--PrimaryColor)";
                            if (check) check.style.display = "flex";
                        } else {
                            input.checked = false;
                            lbl.style.boxShadow = "none";
                            if (lbl.dataset.value === "credit") {
                                lbl.style.border = "2px dashed #dcdcdc";
                            } else {
                                lbl.style.border = "2px solid #dcdcdc";
                            }
                            if (check) check.style.display = "none";
                        }
                    });
                }

                labels.forEach((lbl) => {
                    lbl.addEventListener("click", () => {
                        const input = lbl.querySelector(
                            'input[name="unlockOption"]'
                        );
                        if (!input) return;
                        if (input.disabled) return;
                        updateSelection(lbl.dataset.value);
                    });
                });

                // default to pay
                updateSelection("pay");
            },
            preConfirm: async () => {
                try {
                    const selected = document.querySelector(
                        'input[name="unlockOption"]:checked'
                    );
                    const val = selected ? selected.value : "pay";
                    if (val === "credit") {
                        // user chose to use credit — call unlock handler and wait
                        await handleUnlock(CIN);
                        return { used: "credit" };
                    } else {
                        // user chose to pay — collect billing details first, then create order/open Razorpay
                        setPendingUnlockCIN(CIN);
                        setFetchingBilling(true);
                        try {
                            const invoiceRes = await getUserInvoiceForm().catch(
                                () => null
                            );
                            if (
                                invoiceRes?.data?.Status === 1 &&
                                invoiceRes.data.data
                            ) {
                                const d = invoiceRes.data.data;
                                setBillingDetails({
                                    fullName: d.fullName || "",
                                    email: d.email || "",
                                    mobileNumber: d.mobileNumber || "",
                                    address1: d.address1 || "",
                                    address2: d.address2 || "",
                                    city: d.city || "",
                                    state: d.state || "",
                                    pincode: d.pincode || "",
                                    GSTIN: d.GSTIN || "",
                                    invoiceType: d.invoiceType || "B2C",
                                });
                            }
                        } catch (_) {}
                        setFetchingBilling(false);
                        setShowBillingModal(true);
                        return { used: "showBilling" };
                    }
                } catch (err) {
                    Swal.showValidationMessage(
                        `Request failed: ${err.message}`
                    );
                    throw err;
                }
            },
        });
    };
    return (
        <Layout Active={"Company Details"}>
            <div className={styles.CompanyDetails_main_page}>
                <div className={styles.Companytopmain}>
                    <div className={styles.CompanyDetails}>
                        {/* <h5 className={styles.Companyname}>{companyName || "N/A"}</h5> */}
                        <h5 className={styles.Companyname}>
                            {companyName ? companyName.toUpperCase() : "N/A"}
                        </h5>

                        <div className={styles.CompanyDetails_share}>
                            <div
                                className={styles.CompanyDetails_sharebutton}
                                // onClick={handleShareClick}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleShareClick(e);
                                }}>
                                <CiShare2 className={styles.sharebuttonIcon} />
                                Share
                            </div>
                            {showShareOptions && (
                                <div className={styles.socialIcons}>
                                    <a
                                        href={`https://facebook.com/sharer/sharer.php?u=${window.location.href}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()} // Stop propagation here as well
                                    >
                                        <FaFacebook
                                            className={styles.socialIcon}
                                        />
                                    </a>
                                    <a
                                        href={`https://twitter.com/intent/tweet?url=${window.location.href}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()} // Stop propagation here as well
                                    >
                                        <FaSquareXTwitter
                                            className={styles.socialIcon}
                                        />
                                    </a>
                                    <a
                                        href={`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()} // Stop propagation here as well
                                    >
                                        <FaLinkedin
                                            className={styles.socialIcon}
                                        />
                                    </a>
                                    <a
                                        href={`https://plus.google.com/share?url=${window.location.href}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()} // Stop propagation here as well
                                    >
                                        <FaGoogle
                                            className={styles.socialIcon}
                                        />
                                    </a>
                                    <a
                                        href={`https://wa.me/?text=${window.location.href}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()}>
                                        <FaWhatsapp
                                            className={styles.socialIcon}
                                        />
                                    </a>
                                    {/* Instagram web share using URL parameter */}
                                    <a
                                        href={`https://www.instagram.com/stories/create?url=${encodeURIComponent(
                                            window.location.href
                                        )}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => e.stopPropagation()}>
                                        <FaInstagram
                                            className={styles.socialIcon}
                                        />
                                    </a>

                                    <a
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigator.clipboard.writeText(
                                                window.location.href
                                            );
                                            Swal.fire({
                                                icon: "success",
                                                title: "Copied!",
                                                text: "Link copied to clipboard",
                                                timer: 1500,
                                                showConfirmButton: false,
                                            });
                                        }}
                                        className={styles.copyLinkButton}>
                                        <FaLink />
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={styles.about_body_button}>
                        {isLocked ? (
                            <>
                                <span>Locked</span>
                                <button
                                    className={styles.about_body_button_one}
                                    onClick={() => unlockCompany(CIN)}
                                    disabled={loading}>
                                    <IoMdLock />
                                    {lockload ? "Unlocking..." : "Unlock"}
                                </button>
                            </>
                        ) : (
                            <>
                                <span>
                                    Last Updated {" "}
                                    {new Date(
                                        dateOfPurchase
                                    ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    })}
                                </span>
                                {purchaseData?.purchasedStatus === "pending" ? (
                                    <button
                                        className={styles.about_body_button_one}
                                        disabled>
                                        <TbRefresh />
                                        Updating
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => setShowDownloadModal(true)}
                                        className={styles.about_body_button_one}>
                                        <MdFileDownload />
                                        Download
                                    </button>
                                )}
                            </>
                        )}

                        {/* ✅ Refresh should always be visible */}

                        {/* !isLocked  */}

                        {true && (
                            <button
                                className={styles.about_body_button_one}
                                onClick={handleRefresh}
                                disabled={refreshLoading}>
                                <TbRefresh />
                                {refreshLoading ? "updating..." : "update"}
                            </button>
                        )}

                        {/* ✅ Show last refresh time if available */}
                        {updatedRefreshTime && (
                            <small style={{ marginTop: "4px", color: "#555" }}>
                                ({getTimeAgo(updatedRefreshTime)})
                            </small>
                        )}
                    </div>
                </div>

                <div className={styles.Dashboard_container}>
                    <div className={styles.sub_container}>
                        <div className={styles.bodymainbtncontainer}>
                            <div className={styles.body_subcontainer}>
                                <span
                                    type="button"
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(1)}`}
                                    onClick={() => handleStatusButtonClick(1)}>
                                    <IoMdBusiness size={20} />
                                    About the Company
                                </span>

                                <span
                                    type="button"
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(2)}`}
                                    onClick={() => handleStatusButtonClick(2)}>
                                    <FaUsers size={20} />
                                    Directors
                                </span>
                                <span
                                    type="button"
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(3)}`}
                                    onClick={() => handleStatusButtonClick(3)}>
                                    <RiFundsLine size={20} />
                                    Active Charges
                                    {/* {isLocked && <FaLock size={20} />} */}
                                </span>
                                <span
                                    type="button"
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(4)}`}
                                    onClick={() => {
                                        if (isMarked) {
                                            handleStatusButtonClick(4);
                                        }
                                    }}>
                                    <PiTreeStructureFill size={20} />
                                    Company Structure
                                    {/* {isLocked ? <FaLock size={20} /> : <FaUnlock size={20} />} */}
                                    {(isLocked || !isMarked) && (
                                        <FaLock size={20} />
                                    )}
                                </span>
                                <span
                                    type="button"
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(5)}`}
                                    onClick={() => {
                                        if (isMarked) {
                                            handleStatusButtonClick(5);
                                        }
                                    }}>
                                    <CgEditHighlight size={20} />
                                    Company Highlights
                                    {/* {isLocked ? <FaLock size={20} /> : <FaUnlock size={20} />} */}
                                    {(isLocked || !isMarked) && (
                                        <FaLock size={20} />
                                    )}
                                </span>
                                <span
                                    type="button"
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(6)}`}
                                    onClick={() => {
                                        if (isMarked) {
                                            handleStatusButtonClick(6);
                                        }
                                    }}>
                                    <BsFillClipboard2DataFill size={20} />
                                    Financial Data
                                    {/* {isLocked ? <FaLock size={20} /> : <FaUnlock size={20} />} */}
                                    {(isLocked || !isMarked) && (
                                        <FaLock size={20} />
                                    )}
                                </span>
                                <span
                                    type="button"
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(7)}`}
                                    onClick={() => {
                                        if (isMarked) {
                                            handleStatusButtonClick(7);
                                        }
                                    }}>
                                    <MdSwitchAccessShortcutAdd size={20} />
                                    Charge Overview
                                    {/* {isLocked ? <FaLock size={20} /> : <FaUnlock size={20} />} */}
                                    {(isLocked || !isMarked) && (
                                        <FaLock size={20} />
                                    )}
                                </span>
                                <span
                                    type="button"
                                    disabled={!isMarked}
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(8)}`}
                                    onClick={() => {
                                        if (isMarked) {
                                            handleStatusButtonClick(8);
                                        }
                                    }}>
                                    <AiFillFund size={20} />
                                    Compliance Check
                                    {/* {isLocked ? <FaLock size={20} /> : <FaUnlock size={20} />} */}
                                    {(isLocked || !isMarked) && (
                                        <FaLock size={20} />
                                    )}
                                </span>
                                <span
                                    type="button"
                                    disabled={!isMarked}
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(9)}`}
                                    onClick={() => {
                                        if (isMarked) {
                                            handleStatusButtonClick(9);
                                        }
                                    }}>
                                    <RiFileSearchFill size={20} />
                                    Reference Documents
                                    {/* {isLocked ? <FaLock size={20} /> : <FaUnlock size={20} />} */}
                                    {(isLocked || !isMarked) && (
                                        <FaLock size={20} />
                                    )}
                                </span>
                                <span
                                    type="button"
                                    className={`${styles["body_button"]
                                        } ${isActiveButton(10)}`}
                                    onClick={() => handleStatusButtonClick(10)}>
                                    <BsRobot size={20} />
                                    AI Assistant
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.bodycontainer}>
                        {status === 1 ? (
                            <Aboutcompany
                                refreshLoading={refreshLoading}
                                companyInfo={companyInfo}
                                setCompanyInfo={setCompanyInfo}
                                updatedRefreshTime={updatedRefreshTime}
                                unlockAPI={() => unlockCompany(CIN)}
                                isLocked={isLocked} // ✅ pass state from CompanyDetails
                            />
                        ) : status === 2 ? (
                            <Directorslist
                                companyInfo={companyInfo}
                                refreshLoading={refreshLoading}
                                setCompanyInfo={setCompanyInfo}
                                isRefresh={
                                    status === 2 && updatedRefreshTime
                                }
                                cin={cin}
                            />
                        ) : status === 3 ? (
                            <IndexCharges refreshLoading={refreshLoading} />
                        ) : status === 4 ? (
                            <Companystructure refreshLoading={refreshLoading}
                                companyInfo={companyInfo}
                                setCompanyInfo={setCompanyInfo}
                                isSubScribe={isSubScribe}
                            />
                        ) : status === 5 ? (
                            <CompanyHighlights refreshLoading={refreshLoading}
                                companyInfo={companyInfo}
                                setCompanyInfo={setCompanyInfo}
                                isSubScribe={isSubScribe}
                                companyName={companyName}
                            />
                        ) : status === 6 ? (
                            <FinacialData isSubScribe={isSubScribe} refreshLoading={refreshLoading} />
                        ) : status === 7 ? (
                            <Chargedetails isSubScribe={isSubScribe} companyName={companyName} refreshLoading={refreshLoading} />
                        ) : status === 8 ? (
                            <ComplianceCheck
                                Companyname={companyName}
                                setCompanyInfo={setCompanyInfo}
                                isSubScribe={isSubScribe} refreshLoading={refreshLoading}
                            />
                        ) : status === 9 ? (
                            <SourceDocuments
                                isSubScribe={isSubScribe}
                                companyInfo={companyInfo} refreshLoading={refreshLoading}
                                setCompanyInfo={setCompanyInfo}
                            />
                        ) : status === 10 ? (
                            <CompanyChatbot
                                cin={cin || CIN || "L24230TG1988PLC009102"}
                                companyName={companyName}
                            />
                        ) : null}
                    </div>
                </div>
            </div>

            {/* Download Modal */}

            {showDownloadModal && (
                <DownloadModal
                    onClose={() => setShowDownloadModal(false)}
                    onDownload={handleDownload}
                    Companyname={companyName}
                />
            )}

            {/* Billing Modal (one-time payment unlock) */}
            {showBillingModal && (
                <div className={billingStyles.modalOverlay}>
                    <div className={billingStyles.modalContent}>
                        <div className={billingStyles.modalHeader}>
                            <div>
                                <h2>Billing Details</h2>
                                <p>Enter your billing address for invoice generation</p>
                            </div>
                            <button
                                className={billingStyles.closeBtn}
                                onClick={() => setShowBillingModal(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className={billingStyles.modalBody}>
                            <div className={billingStyles.formRow}>
                                <div className={billingStyles.formGroup}>
                                    <label>Full Name *</label>
                                    <input
                                        type="text"
                                        name="fullName"
                                        value={billingDetails.fullName}
                                        onChange={handleBillingInputChange}
                                        placeholder="John Doe"
                                    />
                                </div>
                                <div className={billingStyles.formGroup}>
                                    <label>Email *</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={billingDetails.email}
                                        onChange={handleBillingInputChange}
                                        placeholder="you@example.com"
                                    />
                                </div>
                            </div>
                            <div className={billingStyles.formGroup}>
                                <label>Phone *</label>
                                <input
                                    type="text"
                                    name="mobileNumber"
                                    value={billingDetails.mobileNumber}
                                    onChange={handleBillingInputChange}
                                    placeholder="+91 98765 43210"
                                />
                            </div>
                            <div className={billingStyles.formGroup}>
                                <label>Address Line 1 *</label>
                                <input
                                    type="text"
                                    name="address1"
                                    value={billingDetails.address1}
                                    onChange={handleBillingInputChange}
                                    placeholder="Building / Street"
                                />
                            </div>
                            <div className={billingStyles.formGroup}>
                                <label>Address Line 2</label>
                                <input
                                    type="text"
                                    name="address2"
                                    value={billingDetails.address2}
                                    onChange={handleBillingInputChange}
                                    placeholder="Landmark (optional)"
                                />
                            </div>
                            <div className={billingStyles.formRow}>
                                <div className={billingStyles.formGroup}>
                                    <label>City *</label>
                                    <input
                                        type="text"
                                        name="city"
                                        value={billingDetails.city}
                                        onChange={handleBillingInputChange}
                                        placeholder="Mumbai"
                                    />
                                </div>
                                <div className={billingStyles.formGroup}>
                                    <label>State *</label>
                                    <select
                                        name="state"
                                        value={billingDetails.state}
                                        onChange={handleBillingInputChange}
                                        className={billingStyles.stateSelect}
                                    >
                                        <option value="">Select State</option>
                                        {statesList.map((st) => (
                                            <option key={st.stateId} value={st.stateName}>
                                                {st.stateName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className={billingStyles.formGroup}>
                                    <label>Pincode *</label>
                                    <input
                                        type="text"
                                        name="pincode"
                                        value={billingDetails.pincode}
                                        onChange={handleBillingInputChange}
                                        placeholder="400001"
                                    />
                                </div>
                            </div>
                            <div className={billingStyles.gstSection}>
                                <label>GSTIN (Optional)</label>
                                <input
                                    type="text"
                                    name="GSTIN"
                                    value={billingDetails.GSTIN}
                                    onChange={handleBillingInputChange}
                                    placeholder="22AAAAA0000A1Z5"
                                />
                                <p className={billingStyles.gstNote}>
                                    Enter your GST number for a GST-compliant invoice
                                </p>
                            </div>
                            <div className={billingStyles.summarySection}>
                                <div className={billingStyles.summaryLine}>
                                    <span>Subtotal</span>
                                    <span>₹{billingSubtotal.toLocaleString("en-IN")}</span>
                                </div>
                                <div className={billingStyles.summaryLine}>
                                    <span>GST ({billingGstPercentage}%)</span>
                                    <span>₹{Math.round(billingGst).toLocaleString("en-IN")}</span>
                                </div>
                                <div
                                    className={`${billingStyles.summaryLine} ${billingStyles.finalTotal}`}
                                >
                                    <span>Total</span>
                                    <span className={billingStyles.totalVal}>
                                        ₹{Math.round(billingTotal).toLocaleString("en-IN")}
                                    </span>
                                </div>
                            </div>
                            <button
                                className={billingStyles.proceedBtn}
                                onClick={handleFinalPayment}
                            >
                                Proceed to Pay ₹{Math.round(billingTotal).toLocaleString("en-IN")}
                            </button>
                            <p className={billingStyles.secureNote}>
                                <FaShieldAlt /> Secure payment • Invoice will be emailed
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {/* Floating Chat Trigger Button when not on Tab 10 */}
            {status !== 10 && (
                <button
                    type="button"
                    className={chatbotStyles.floatingLauncherBtn}
                    onClick={() => setShowFloatingChat(!showFloatingChat)}
                    title="Ask AI Assistant"
                    aria-label="Ask AI Assistant">
                    <BsRobot size={24} />
                </button>
            )}

            {/* Floating Chat Window when opened via floating trigger */}
            {showFloatingChat && status !== 10 && (
                <CompanyChatbot
                    cin={cin || CIN || "L24230TG1988PLC009102"}
                    companyName={companyName}
                    isFloating={true}
                    onClose={() => setShowFloatingChat(false)}
                />
            )}
        </Layout>
    );
};

export default CompanyDetails;
